import { Card, SxProps, useTheme } from '@mui/material';
import { forwardRef } from 'react';
import { useResponsive } from 'src/hooks/use-responsive';
import { JooiceTheme } from 'src/theme/theme';

interface Props {
  children?: React.ReactNode;
  sx?: SxProps;
  noShadow?: boolean;
  noBorder?: boolean;
  onClick?: VoidFunction;
  onMouseEnter?: VoidFunction;
  onMouseLeave?: VoidFunction;
}

const ResponsiveCard = forwardRef<HTMLDivElement, Props>(
  ({ children, sx, noShadow = false, noBorder = false, onClick, onMouseEnter, onMouseLeave }, ref) => {
    const theme = useTheme<JooiceTheme>();
    const onMobile = useResponsive('down', 'sm');
    return (
      <Card
        ref={ref}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        sx={{
          boxShadow: noShadow ? 0 : 5,
          border: noBorder ? 0 : noShadow ? 1 : 0,
          borderColor: theme.palette.pearl[300],
          borderRadius: 2,
          padding: onMobile ? 2 : 3,
          ...sx,
        }}
      >
        {children}
      </Card>
    );
  },
);

ResponsiveCard.displayName = 'ResponsiveCard';

export default ResponsiveCard;
